module.exports = __webpack_public_path__ + "media/img/pages/profile/csl ger 5-91054a35e66cf72e517635713f4ea623.jpg";